export default function shouldHideRating({
  attendee, rating, isExpired, venue: { survey } = {}, bookOnBehalf,
}) {
  /*
    IF a reservation:
    a) belongs to a user that IS NOT host
    b) is from a venue that IS a servy (survey) venue
    c) is expired
    THEN: do not allow rating and do not show an existing rating
    - MY
  */
  if (!!attendee && 'type' in attendee && !!attendee.type && attendee.type !== 'host') {
    return true;
  }

  if (!!survey && 'version' in survey && +survey.version === 1) {
    return true;
  }

  if (!rating && isExpired) {
    return true;
  }

  if (bookOnBehalf) {
    return true;
  }

  return false;
}
